/**
 * Simple logging configuration for Consola
 */
export interface LoggingConfig {
  /**
   * Enable/disable logging
   * @default true
   */
  enabled?: boolean;

  /**
   * Consola log level (0-5)
   * 0=Error, 1=Warn, 2=Log, 3=Info, 4=Debug, 5=Trace
   * @default 3
   */
  level?: number;
}

/**
 * Default logging configuration
 */
export const DEFAULT_LOGGING_CONFIG: LoggingConfig = {
  enabled: true,
  level: 3, // Info level
};

/**
 * Log namespaces for tagging
 */
export const LOG_NAMESPACES = {
  CORE: 'eventmsg:core',
  PROTOCOL: 'eventmsg:protocol',
  TRANSPORT: 'eventmsg:transport',
  TRANSPORT_WEBBLE: 'eventmsg:transport:webble',
} as const;
